export default [
    {
        path: '/products',
        name: 'products',
        component: () => import('@/views/menu/product/products.vue'),
        meta: {
            pageTitle: 'مدیریت محصولات',
            action: 'show',
            resource: 'BlogManager',
        },
    },
    {
        path: '/products/add',
        name: 'addProduct',
        component: () => import('@/views/menu/product/productItem.vue'),
        meta: {
            pageTitle: 'ایجاد محصول جدید',
            action: 'show',
            resource: 'BlogManager',
        },
    },
    {
        path: '/products/edit/:id',
        name: 'updateProduct',
        component: () => import('@/views/menu/product/productItem.vue'),
        meta: {
            pageTitle: 'ویرایش محصول',
            action: 'show',
            resource: 'BlogManager',
        },
    },
]